import { Component, Input } from '@angular/core';
import { getCountdownBackground } from 'src/app/shared/payment.helper';

@Component({
  selector: 'app-payment-failed-content',
  templateUrl: './payment-failed-content.component.html',
  styleUrls: ['./payment-failed-content.component.scss'],
})
export class PaymentFailedContentComponent {
  @Input() countdown: number;
  readonly getCountdownBackground = getCountdownBackground;
}
